import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';
import CompanyPage from 'adminPanel/modules/Companies/pages/CompanyPage';

const CompaniesPage = lazy(() => import('./pages/CompaniesPage'));

export const ROUTES = [
    {
        path: '/companies',
        element: (
            <Suspense fallback={<Spinner block />}>
                <CompaniesPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/companies/:companyId/*',
        element: (
            <Suspense fallback={<Spinner block />}>
                <CompanyPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
